import { Component, Input } from '@angular/core';

import { DialogComment } from '../../model';
import { PhxLocalizationService } from '../../services/phx-localization.service';
import { PhoenixCommonModuleResourceKeys } from '../../PhoenixCommonModule.resource-keys';

@Component({
  selector: 'app-phx-dialog-comment-template',
  templateUrl: './phx-dialog-comment-template.component.html',
  styleUrls: ['./phx-dialog-comment-template.component.less']
})
export class PhxDialogCommentTemplateComponent {
  @Input() title: string;
  @Input() helpblock: string;
  @Input() label: string;
  @Input() subLabelText: string;
  @Input() commentPlaceholder: string;
  @Input() maxLength = 4000;
  @Input() saveButtonText: string;
  @Input() showSelectionControls: boolean;
  @Input() saveCallbackFn: (comment: string) => void;
  @Input() cancelCallbackFn: () => void;
  @Input() modalRefHide: () => void;
  @Input() saveReasonIDsCallbackFn: (dialogComment: DialogComment) => void;

  @Input() selectLabel = 'Select the decline reason(s)';
  @Input() selectMode: 'tagBox' | 'select' = 'tagBox';
  @Input() cancelButtonText?: string;
  @Input() isCommentRequired = true;

  yesFlag = false;
  comment: string;

  showDeclineReasonList: boolean;
  declineReasonList: Array<{ Id: number | string; Reason: string }>;
  dialogResult: DialogComment;

  constructor(private localizationService: PhxLocalizationService) {
    this.title = this.localizationService.translate(PhoenixCommonModuleResourceKeys.phxDialogComment.title);
    this.helpblock = this.localizationService.translate(PhoenixCommonModuleResourceKeys.phxDialogComment.helpblock);
    this.saveButtonText = this.localizationService.translate(PhoenixCommonModuleResourceKeys.phxDialogComment.saveBtn);
    this.dialogResult = {} as DialogComment;
  }
  updateComment(event: any) {
    this.comment = event;
    this.dialogResult.Comment = event;
  }

  onDeclineReasonsChanged(data: any) {
    this.dialogResult.DeclineReasons = data.value;
  }

  isValid() {
    if (this.showDeclineReasonList) {
      const isCommentValid = !this.isCommentRequired || this.dialogResult.Comment?.trim();
      return isCommentValid && this.dialogResult.DeclineReasons?.length;
    } else {
      return !this.isCommentRequired || this.comment?.trim();
    }
  }

  save() {
    this.yesFlag = true;
    this.close();
    if (this.saveCallbackFn) {
      this.saveCallbackFn(this.comment);
    }
    if (this.saveReasonIDsCallbackFn && this.showDeclineReasonList) {
      this.saveReasonIDsCallbackFn(this.dialogResult);
    }
  }
  close() {
    if (this.modalRefHide) {
      this.modalRefHide();
    } else {
      console.error('modalRefHide is required');
    }
    if (this.yesFlag === false && this.cancelCallbackFn) {
      this.cancelCallbackFn();
    }
  }
  placeholderProvided() {
    return this.commentPlaceholder != null; // null or undefined denotes no placeholder was provided. '' is considered a valid placeholder.
  }
}
